import { Spinner, Box } from 'theme-ui';

import { Locale } from '@snippets';

import { Amount } from './Amount';
import { themed } from './Price.theme';

export const Price = themed(({ theme, selectedVariant }) => {
  return (
    <Box sx={theme.wrapper}>
      {selectedVariant && (
        <Locale.Variant variant={selectedVariant}>
          <Locale.Price>{(props) => <Amount {...props} />}</Locale.Price>

          <Locale.Loader>
            <Spinner sx={theme.loader} />
          </Locale.Loader>

          {/* <Locale.Error>{({ errors }) => errors?.join(',')}</Locale.Error> */}
        </Locale.Variant>
      )}
    </Box>
  );
});
